import ObjectDisplayController from "ips/ac/controller/scfld/ObjectDisplay.controller";
import formatter from "ips/ac/model/formatter";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";

/**
 * Product controller
 *
 * @class
 * @constructor
 * @public
 * @extends ips.ac.controller.scfld.ObjectDisplay.controller
 * @namespace ips.ac.data.product.controller
 */
export default class ProductDetails extends ObjectDisplayController {

  public formatter = formatter;

  protected _onObjectMatched(oEvent: Route$PatternMatchedEvent): void {
    super._onObjectMatched(oEvent);
    const sProductPath = (oEvent.getParameter("arguments") as { path?: string })?.path;
    if (!sProductPath) {
      return;
    }
    void this._loadCount(sProductPath + "/OrderLineDetails", "/OrderlineCount");
    void this._loadAttachmentCount(sProductPath);
  }
}
